import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';


import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox, InputAdornment
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller } from "react-hook-form";
import { IAppPropsWithRoute } from '../../../common/types';
import Handover from './Handover';
import { useState } from 'react';
import IndexedDb from '../IndexedDb';
import AcuityPopup from './Popups/AcuityPopup';
import { KeyboardDatePicker, MuiPickersUtilsProvider, TimePickerView } from '@material-ui/pickers';
import { format, getDate } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { time, timeStamp } from 'console';
import GooglePlaceAutoComplete from '../GooglePlaceAutoComplete';
import { SelectItem } from './PatientIdentification';
import TimeInput from '../../ui/TimeInput';

interface PcrWidgetProps extends IAppPropsWithRoute {

};

const SubFormWidget: React.FC<PcrWidgetProps> = () => {
    const classes = useStyles();
    const history = useHistory();

    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");

    const [Indexdb, setIndexdb] = useState("");
    const [acuityPopup, setAcuityPopup] = React.useState(false);

    const [HandoverReceivedIdb, SetHandoverReceivedIdb] = useState<String>("");
    const [HandoverReceivedRole, SetHandoverReceivedRole] = useState<String>("");
    const [HandoverReceivedtimeIdb, SetHandoverReceivedtimeIdb] = useState<Date>();
    const [MultiPrincipleDiagnosisIdb, SetMultiPrincipleDiagnosisIdb] = useState<String>("");
    const [P3jobsIdb, SetP3jobsIdb] = useState<String>("");
    const [PresentingComplaintIdb, SetPresentingComplaintIdb] = useState<String>("");
    const [PrincipleDiagnosisIdb, SetPrincipleDiagnosisIdb] = useState<String>("");
    const [TimeofPresentationIdb, SetTimeofPresentationIdb] = useState<Date>();
    const [handoverreceivednameIdb, SethandoverreceivednameIdb] = useState<String>("");
    const [pickuplocationIdb, SetpickuplocationIdb] = useState<String>("");
    const [acuityIdb, SetacuityIdb] = useState<SelectItem[]>([]);
    const [isNSWLocationIdb, SetisNSWLocationIdb] = useState<any>(null);
    const [WorkplaceinjuryIdb, SetWorkplaceinjuryIdb] = useState();

    React.useEffect(() => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
    }, [])

    React.useEffect(() => {
        getindexdbvalues();
    }, [pcrType])


    const [selectedDate, setSelectedDate] = useState<Date>();
    const handleDateChange = (date: any, Key: any) => {
        if (Key == "HandoverReceiveddate") {
            setSelectedDate(date);
            setValue("Hand_over_Received", date)
        }
        if (Key == "HandoverReceivedtime") {
            SetHandoverReceivedtimeIdb(date);
            setValue("handover_received_time", date)
        }
        if (Key == "TimeofPresentation") {
            SetTimeofPresentationIdb(date);
            setValue("time_of_presentation", date)
        }
    };

    const handleSituationindexdbsave = async (Key: any, value: any): Promise<void> => {
        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('Situation', Key);
            await indexedDb.putValue('Situation', { column: value !== undefined ? value : null, Patid: 0 }, Key);
        }
    }

    const getindexdbvalues = async (): Promise<void> => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        if (db != null && db != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('Situation');
            for (let i = 0; i < val.length; i++) {
                if (val[i].Key == "HandoverReceived") {
                    setValue("handover_received_name", val[i].value.column);
                }
                if (val[i].Key == "HandoverReceivedRole") {
                    SetHandoverReceivedRole(val[i].value.column);
                }
                if (val[i].Key == "HandoverReceiveddate") {
                    var dt = (val[i].value.column);
                    setSelectedDate(val[i].value.column);
                }
                if (val[i].Key == "HandoverReceivedtime") {
                    var dt = (val[i].value.column);
                    SetHandoverReceivedtimeIdb(val[i].value.column);
                }
                if (val[i].Key == "MultiPrincipleDiagnosis") {
                    SetMultiPrincipleDiagnosisIdb(val[i].value.column);
                }
                if (val[i].Key == "P3jobs") {
                    SetP3jobsIdb(val[i].value.column);
                }
                if (val[i].Key == "PresentingComplaint") {
                    SetPresentingComplaintIdb(val[i].value.column);
                    setValue("Presenting_Complaint", val[i].value.column);
                }

                if (val[i].Key == "PrincipleDiagnosis") {
                    SetPrincipleDiagnosisIdb(val[i].value.column);
                }
                if (val[i].Key == "TimeofPresentation") {
                    SetTimeofPresentationIdb(val[i].value.column);
                    setValue("time_of_presentation", val[i].value.column)
                }
                if (val[i].Key == "handoverreceivedname") {
                    SethandoverreceivednameIdb(val[i].value.column);
                }
                if (val[i].Key == "pickuplocation") {
                    SetpickuplocationIdb(val[i].value.column);
                }
                if (val[i].Key == "acuity") {
                    SetacuityIdb(val[i].value.column);
                    setValue("acuity", val[i].value.column);
                    if(val[i].value.column == "B" ||
                        val[i].value.column == "C" ||
                        val[i].value.column == "D" ||
                        val[i].value.column == "E") {
                            SetisNSWLocationIdb(true);
                        }
                }
                if (val[i].Key == "isNSWLocation") {
                    SetisNSWLocationIdb(val[i].value.column);
                }
                if (val[i].Key == "Workplaceinjury") {
                    setValue("workplace_injury", val[i].value.column);
                }
            }
        }
    }


    return (
        <div>
            <div className={classes.pcrAddTabHeading}>
                <div>
                    SITUATION
                </div>
            </div>
            <Grid container className={classes.formContainer} spacing={3}>

                {(pcrType === "2" || pcrType === "3") && (<>
                    <Grid item xs={12} sm={12}>
                        <div className={classes.formControlLabel}>
                            <Icons.RequiredIcon />PICK UP LOCATION
                        </div>
                        <Controller
                            name="pickuplocation"
                            defaultValue={pickuplocationIdb}
                            control={control}
                            render={({ onChange, onBlur, value }) => (
                                <>
                                    <GooglePlaceAutoComplete
                                        placeholder=""
                                        onInputChange={(value: string) => {
                                            onChange(value);
                                            onBlur();
                                            handleSituationindexdbsave('pickuplocation', value);
                                            SetpickuplocationIdb(value);
                                        }}
                                        onChange={(value: any) => {
                                            if (value) {
                                                handleSituationindexdbsave('pickuplocationgoogleplaceid', value.place_id);
                                            }
                                        }}
                                        value=""
                                        inputValue={value}
                                        singleLine={true}
                                        hideNoOption={true}
                                    />
                                    {errors.pickuplocation && (
                                        <FormHelperText style={{ color: "red" }}>{errors.pickuplocation ? errors.pickuplocation.message : ""}</FormHelperText>

                                    )}
                                </>
                            )}
                            rules={{
                                validate: (value) => {
                                    if (value === "") {
                                        return "Pick Up Location is required";
                                    }
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.formControlLabel}>
                                    <Icons.RequiredIcon />PRINCIPLE DIAGNOSIS
                                </div>
                                <Controller
                                    control={control}
                                    defaultValue={PrincipleDiagnosisIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <TextField
                                                onChange={e => {
                                                    onChange(e.target.value);
                                                }}
                                                onBlur={e => {
                                                    handleSituationindexdbsave('PrincipleDiagnosis', e.target.value);
                                                }}
                                                value={value}
                                                name={name}
                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                inputProps={{ maxLength: 200, minLength: 0, autocomplete: 'disabled' }}
                                                required
                                                variant="outlined"
                                                placeholder=""
                                            />
                                            {errors.Principle_Diagnosis && (
                                                <FormHelperText style={{ color: "red" }}>{errors.Principle_Diagnosis ? errors.Principle_Diagnosis.message : ""}</FormHelperText>

                                            )}
                                        </>
                                    )}
                                    name="Principle_Diagnosis"
                                    rules={{
                                        required: "Principle Diagnosis is required",
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <Controller
                                    control={control}
                                    name="more_information"
                                    defaultValue={MultiPrincipleDiagnosisIdb}
                                    render={props => (
                                        <TextField
                                            defaultValue={MultiPrincipleDiagnosisIdb}
                                            onBlur={e => {
                                                handleSituationindexdbsave('MultiPrincipleDiagnosis', e.target.value);
                                            }}
                                            variant="outlined"
                                            InputProps={{ classes: { root: classes.multilinetextFieldInput } }}
                                            inputProps={{ maxLength: 500, minLength: 0, autocomplete: 'disabled' }}
                                            error={Boolean(errors.more_information)}
                                            helperText={errors.more_information ? errors.more_information.message : ""}
                                            placeholder="More information. write ''none'' if not applicable"
                                            multiline
                                            rows={7}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.formControlLabel}>
                                    ACUITY
                                </div>
                                <Controller
                                    control={control}
                                    name="acuity"
                                    defaultValue={acuityIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <FormControl fullWidth error={Boolean(errors.acuity)}>
                                            <Select
                                                name={name}
                                                value={value}
                                                defaultValue={acuityIdb}
                                                className={classes.selectField}
                                                IconComponent={KeyboardArrowDownIcon}
                                                displayEmpty
                                                fullWidth
                                                variant="outlined"
                                                readOnly
                                                onClick={() => setAcuityPopup(true)}
                                                onChange={(e: any) => {
                                                    onChange(e.target.value)
                                                    handleSituationindexdbsave('acuity', e.target.value)
                                                }}
                                            >
                                                <MenuItem key="None" value="">Choose</MenuItem>
                                                {/* NON-NSW SCALE */}
                                                <MenuItem key={5} value="5">High Acuity</MenuItem>
                                                <MenuItem key={6} value="6">Medium Acuity</MenuItem>
                                                <MenuItem key={7} value="7">Low Acuity</MenuItem>
                                                {/* NSW SCALE */}
                                                <MenuItem key={1} value="1">Class B</MenuItem>
                                                <MenuItem key={2} value="2">Class C</MenuItem>
                                                <MenuItem key={3} value="3">Class D</MenuItem>
                                                <MenuItem key={4} value="4">Class E</MenuItem>
                                            </Select>
                                            {errors.acuity && (
                                                <FormHelperText style={{ color: "red" }}>{errors.acuity ? errors.acuity.message : ""}</FormHelperText>
                                            )}
                                        </FormControl>
                                    )}
                                    rules={{
                                        // required: "Acuity is required",
                                    }}
                                />
                                <AcuityPopup
                                    popState={acuityPopup}
                                    setPopState={setAcuityPopup}
                                    isNSWLocationIdb={isNSWLocationIdb}
                                    setValue = {setValue}
                                />
                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.formControlLabel}>
                                    <Icons.RequiredIcon />HANDOVER RECEIVED FROM (NAME)
                                </div>
                                <Controller
                                    control={control}
                                    defaultValue={handoverreceivednameIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <React.Fragment>
                                            <TextField
                                                onChange={e => {
                                                    onChange(e)
                                                }}
                                                onBlur={(e) => {
                                                    handleSituationindexdbsave('handoverreceivedname', e.target.value);

                                                }}
                                                value={value}
                                                name={name}
                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                required
                                                inputProps={{ maxLength: 100, minLength: 0, autocomplete: 'disabled' }}
                                                variant="outlined">

                                            </TextField>
                                            <FormHelperText style={{ color: "red" }}>{errors.handover_received_name ? errors.handover_received_name.message : ""}</FormHelperText>

                                        </React.Fragment>
                                    )}

                                    name="handover_received_name"
                                    rules={{
                                        required: "Handover Received From (Name) is required",
                                    }}

                                />

                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.formControlLabel}>
                                    <Icons.RequiredIcon />HANDOVER RECEIVED FROM (ROLE)
                                </div>
                                <Controller
                                    control={control}
                                    defaultValue={HandoverReceivedRole}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <React.Fragment>
                                            <TextField
                                                onChange={e => {
                                                    onChange(e)
                                                }}
                                                onBlur={(e) => {
                                                    handleSituationindexdbsave('HandoverReceivedRole', e.target.value);

                                                }}
                                                value={value}
                                                name={name}
                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                inputProps={{ maxLength: 100, minLength: 0, autocomplete: 'disabled' }}
                                                required
                                                variant="outlined">

                                            </TextField>
                                            <FormHelperText style={{ color: "red" }}>{errors.handover_received_role ? errors.handover_received_role.message : ""}</FormHelperText>

                                        </React.Fragment>
                                    )}

                                    name="handover_received_role"
                                    rules={{
                                        required: "Handover Received From (Role) is required",
                                    }}

                                />

                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.formControlLabel}>
                                    <Icons.RequiredIcon />HANDOVER DATE & TIME (24 HOUR)
                                </div>
                                <Grid container spacing={3}>
                                    <Grid item xs={6} sm={6}>
                                        <Controller
                                            control={control}
                                            defaultValue={selectedDate != null ? selectedDate : null}
                                            render={props => (
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>

                                                    <KeyboardDatePicker
                                                        inputVariant="outlined"
                                                        value={selectedDate || null}
                                                        format="dd/MM/yyyy"
                                                        autoOk={true}
                                                        cancelLabel={false}
                                                        okLabel={false}
                                                        placeholder="DD/MM/YYYY"
                                                        onChange={(e) => {
                                                            if (e !== null) {
                                                                let timestamp = Date.parse(e.toString());
                                                                if (!isNaN(timestamp)) {
                                                                    handleDateChange(e, "HandoverReceiveddate");
                                                                    handleSituationindexdbsave('HandoverReceiveddate', timestamp);
                                                                }
                                                            }
                                                            else {
                                                                handleDateChange(null, "HandoverReceiveddate");
                                                                handleSituationindexdbsave('HandoverReceiveddate', null);
                                                            }
                                                        }
                                                        }

                                                        defaultValue={selectedDate}
                                                        onFocusCapture={(e) => {
                                                            if (e !== null) {
                                                                let timestamp = Date.parse(e.toString());
                                                                if (!isNaN(timestamp)) {
                                                                    handleDateChange(e, "HandoverReceiveddate");
                                                                    handleSituationindexdbsave('HandoverReceiveddate', timestamp);
                                                                }
                                                            }
                                                            else {
                                                                handleDateChange(null, "HandoverReceiveddate");
                                                                handleSituationindexdbsave('HandoverReceiveddate', null);
                                                            }
                                                        }
                                                        }
                                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                                        error={errors.Hand_over_Received}
                                                        helperText={errors.Hand_over_Received ? errors.Hand_over_Received.message : ""}
                                                        keyboardIcon={<Icons.DatePickerIcon />}
                                                    />
                                                </MuiPickersUtilsProvider>

                                            )}
                                            name="Hand_over_Received"
                                            rules={{
                                                required: "Handover Date  is required",
                                            }}
                                        />

                                    </Grid>
                                    <Grid item xs={6} sm={6}>
                                        <Controller
                                            control={control}
                                            name="handover_received_time"
                                            defaultValue={HandoverReceivedtimeIdb != null ? HandoverReceivedtimeIdb : null}
                                            render={props => (
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>

                                                    <TimeInput
                                                        inputVariant="outlined"
                                                        value={HandoverReceivedtimeIdb || null}
                                                        format="HH:mm"
                                                        placeholder="HH:MM"
                                                        autoOk={true}
                                                        cancelLabel={false}
                                                        okLabel={false}
                                                        onChange={(e) => {
                                                            if (e !== null) {
                                                                let timestamp = Date.parse(e.toString());
                                                                if (!isNaN(timestamp)) {
                                                                    handleDateChange(e, "HandoverReceivedtime");
                                                                    handleSituationindexdbsave('HandoverReceivedtime', timestamp);

                                                                }
                                                            }
                                                            else {
                                                                handleDateChange(e, "HandoverReceivedtime");
                                                                handleSituationindexdbsave('HandoverReceivedtime', null);
                                                            }

                                                        }}
                                                        onFocusCapture={(e) => {
                                                            if (e !== null) {
                                                                let timestamp = Date.parse(e.toString());
                                                                if (!isNaN(timestamp)) {
                                                                    handleDateChange(e, "HandoverReceivedtime");
                                                                    handleSituationindexdbsave('HandoverReceivedtime', timestamp);

                                                                }
                                                            }
                                                            else {
                                                                handleDateChange(e, "HandoverReceivedtime");
                                                                handleSituationindexdbsave('HandoverReceivedtime', null);
                                                            }

                                                        }
                                                        }

                                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                                        error={errors.handover_received_time}
                                                        helperText={errors.handover_received_time ? errors.handover_received_time.message : ""}
                                                        keyboardIcon={<Icons.TimePickerIcon />}
                                                    />

                                                </MuiPickersUtilsProvider>

                                            )}
                                            rules={{
                                                required: "Handover Time field is required",
                                            }}


                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </>)}

                {(pcrType === "1" || pcrType === "3") && (<>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.formControlLabel}>
                            <Icons.RequiredIcon />PRESENTING COMPLAINT
                            {pcrType === "3" && (<>
                                <span className={"incident"}>
                                    <Icons.IncidentIcon /> INCIDENT
                                </span>
                            </>)}
                        </div>

                        <Controller
                            control={control}
                            defaultValue={PresentingComplaintIdb}
                            render={({ onChange, onBlur, value, name }) => (
                                <React.Fragment>
                                    <TextField
                                        onChange={e => {
                                            onChange(e)
                                        }}
                                        onBlur={(e) => {
                                            handleSituationindexdbsave('PresentingComplaint', e.target.value);

                                        }}
                                        value={value}
                                        name={name}
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        inputProps={{ maxLength: 200, minLength: 0, autocomplete: 'disabled' }}
                                        required

                                        variant="outlined" placeholder=''>

                                    </TextField>
                                    <FormHelperText style={{ color: "red" }}>{errors.Presenting_Complaint ? errors.Presenting_Complaint.message : ""}</FormHelperText>
                                </React.Fragment>
                            )}

                            name="Presenting_Complaint"
                            rules={{
                                required: "Presenting Complaint is required",
                            }}

                        />

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.formControlLabel}>
                            <Icons.RequiredIcon />TIME OF PRESENTATION
                            {pcrType === "3" && (<>
                                <span className={"incident"}>
                                    <Icons.IncidentIcon /> INCIDENT
                                </span>
                            </>)}
                        </div>

                        <Controller
                            control={control}
                            render={props => (
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <TimeInput
                                        inputVariant="outlined"
                                        value={TimeofPresentationIdb || null}
                                        format="HH:mm"
                                        placeholder="HH:MM"
                                        autoOk={true}
                                        cancelLabel={false}
                                        okLabel={false}
                                        onChange={(e) => {

                                            if (e !== null) {
                                                let timestamp = Date.parse(e.toString());
                                                if (!isNaN(timestamp)) {
                                                    handleDateChange(e, "TimeofPresentation");
                                                    handleSituationindexdbsave('TimeofPresentation', timestamp);
                                                }
                                            }
                                            else {
                                                handleDateChange(e, "TimeofPresentation");
                                                handleSituationindexdbsave('TimeofPresentation', null);
                                            }


                                        }}
                                        onFocusCapture={(e) => {
                                            if (e !== null) {
                                                let timestamp = Date.parse(e.toString());
                                                if (!isNaN(timestamp)) {
                                                    handleDateChange(e, "TimeofPresentation");
                                                    handleSituationindexdbsave('TimeofPresentation', timestamp);
                                                }
                                            }
                                            else {
                                                handleDateChange(e, "TimeofPresentation");
                                                handleSituationindexdbsave('TimeofPresentation', null);
                                            }
                                        }
                                        }

                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        error={errors.time_of_presentation}
                                        helperText={errors.time_of_presentation ? errors.time_of_presentation.message : ""}
                                        keyboardIcon={<Icons.TimePickerIcon />}
                                    />

                                </MuiPickersUtilsProvider>

                            )}
                            name="time_of_presentation"
                            rules={{
                                required: "Time of Presentation is required",
                            }}

                        />

                    </Grid>
                </>)}

                {(pcrType === "1") && (<>
                    <Grid item xs={12} sm={12}>
                        <div className={classes.formControlLabel}>
                            WORKPLACE INJURY?
                        </div>
                        <Controller
                            control={control}
                            name="workplace_injury"
                            defaultValue={WorkplaceinjuryIdb}
                            render={({ onChange, onBlur, value, name }) => (
                                <>
                                    <Grid container className={classes.buttonSwitchField}>
                                        <Grid item xs={7} sm={"auto"}>
                                            <div>
                                                Workplace injury {WorkplaceinjuryIdb}
                                            </div>
                                        </Grid>

                                        <Grid item xs={"auto"} sm={"auto"}>
                                            <button
                                                type="button"

                                                className={value === 1 ? "selected" : ""}
                                                onClick={(e: any) => { onChange(1, handleSituationindexdbsave('Workplaceinjury', 1)) }}
                                            >
                                                Yes
                                            </button>
                                            <button
                                                type="button"

                                                className={value === 0 ? "selected" : ""}
                                                onClick={(e: any) => { onChange(0, handleSituationindexdbsave('Workplaceinjury', 0)) }}
                                            >
                                                No
                                            </button>
                                        </Grid>
                                        {/* <Grid item xs={"auto"} sm={"auto"}>
                                    <button
                                            type="button"
                                            className={value === 1 ? "selected" : ""}
                                            onClick={(e: any) => { onChange(1) }}
                                            onBlur={(e) => {
                                                handleSituationindexdbsave('Workplaceinjury', 1);
                                                
                                            }}
                                        >
                                            Yes
                                        </button>
                                        <button
                                            type="button"
                                            className={value === 0 ? "selected" : ""}
                                            onClick={(e: any) => { onChange(0) }}
                                            onBlur={(e) => {
                                                handleSituationindexdbsave('Workplaceinjury', 0);
                                                
                                            }}
                                        >
                                            No
                                        </button>
                                    </Grid> */}
                                    </Grid>
                                </>
                            )}
                        />
                    </Grid>
                </>)}

            </Grid>
        </div>
    );
}

export default React.memo(withRouter(SubFormWidget));